export interface IAidasOrganisation {
  id?: number;
  name?: string;
  description?: string | null;
}

export const defaultValue: Readonly<IAidasOrganisation> = {};
